import { useNavigate } from "react-router";
import CommonOpacityBackground from "../../components/Common/commonOpacityBackground";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { IoCloseOutline } from "react-icons/io5";
import { Icon, Input } from "semantic-ui-react";
import { useEffect, useMemo, useState } from "react";
import GameCatalog from "../../components/GameCatalog";
import { useDispatch, useSelector } from "react-redux";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import NotFound from "../../components/ProgressBlock/NotFound";
import LazyImage from "../../components/Loading/lazyImage";
import { languageTransfer } from "../../utils/languageTransfer";
import i18next from "i18next";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import useDeviceType from "../../hook/useDeviceType";
import { storeGameConfig } from "../../redux/action/game/gameAction";
import { CloseMenu } from "../../redux/action/action";
import FavoriteGameCatalog from "../../components/FavoriteGameCatalog";

const Search = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const [search, setSearch] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);

  const navigate = useNavigate();

  const isMobile = useDeviceType() === "Mobile";

  const GAMELIST = useSelector((state) => state.isGameList);
  const handleAllGame = useSelector((state) => state.isHandleAllGame);
  const dispatch = useDispatch();
  const {
    newGameList,
    topGameList,
    randomlySelectedGames,
    allGames,
    allGamePlatform,
  } = handleAllGame;
  const allPlatform = useSelector(
    (state) => state.isHandleAllGame.allGamePlatform
  );

  const handleInput = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    if (search) {
      setSearchLoading(true);

      setTimeout(() => {
        setSearchLoading(false);
      }, 1500);
    } else {
      setSearchLoading(false);
    }
  }, [search]);

  const casinoGroup = useMemo(() => {
    if (search) {
      return allPlatform.filter((item) => {
        return item?.platform.toLowerCase().includes(search.toLowerCase());
      });
    }
  }, [search]);

  const gamesGroup = useMemo(() => {
    if (search) {
      return allGames.filter((item) => {
        return item?.[`gameName${languageTransfer({ lang: i18next.language })}`]
          .toLowerCase()
          .includes(search.toLowerCase());
      });
    }
  }, [search, i18next.language]);

  return (
    <CommonOpacityBackground path={-1}>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        // 0A0D0F
        className="md:min-h-[248px] md:max-h-[calc(100vh-92px)] bg-base-light-white dark:bg-base-dark h-full w-full md:w-[500px] md:rounded-[10px] flex flex-col gap-[15px] px-[20px]"
      >
        <CloseDetailPage
          title={i18n("Search")}
          customClose={
            <IoCloseOutline
              className="cursor-pointer hidden md:block"
              onClick={() => {
                navigate(-1);
              }}
            />
          }
        />
        <section>
          <Input
            size="large"
            className="w-full"
            iconPosition="left"
            icon
            placeholder={i18n("Search")}
          >
            <input
              onChange={(e) => {
                handleInput(e);
              }}
              className="!bg-transaction-card dark:!bg-base-light-dark !text-base-light-dark dark:!text-base-light-white"
            />
            <Icon className="!text-light-text" name="search" />
          </Input>
        </section>
        <section className="overflow-y-scroll no-scrollbar py-[15px]">
          <LoadingBlock commonLoading={searchLoading}>
            {search ? (
              <>
                {/* <section className="flex flex-col gap-[15px] mb-[10px]">
                  <span className="text-sm font-medium text-light-text">
                    {i18n("Providers")}
                  </span>
                  <section className="w-full">
                    {casinoGroup.length === 0 ? (
                      <NotFound />
                    ) : (
                      <section className="grid grid-cols-2 gap-[20px]">
                        {casinoGroup.map((plat, index) => {
                          return (
                            <div
                              onClick={() => {
                                navigate(`/casino/category/${plat?.platform}`);
                              }}
                              className={`bg-base-white dark:bg-base-dark text-white cursor-pointer h-[56px] rounded-[7px] py-[18px] px-[7px] flex items-center justify-center hover:bg-hover-transaction-card`}
                            >
                              <img
                                className="w-[60px] object-contain"
                                src={`${COMMON_WEB_PATH}/platformIcon/${plat?.platform}.png`}
                              />
                            </div>
                          );
                        })}
                      </section>
                    )}
                  </section>
                </section> */}
                <section className="flex flex-col gap-[15px]">
                  <span className="text-sm font-medium text-light-text">
                    {i18n("Games")}
                  </span>
                  <section className="w-full">
                    {gamesGroup.length === 0 ? (
                      <NotFound />
                    ) : (
                      <section className="grid grid-cols-1 gap-[20px]">
                        {gamesGroup.map((game, index) => {
                          const gameName =
                            game?.[
                              `gameName${languageTransfer({
                                lang: i18next.language,
                              })}`
                            ];
                          const gameCode = game?.gameCode;
                          const gamePlatform = game?.game_platform;
                          const gameSubType = game?.game_subtype;
                          const platformConfig = allGamePlatform.find(
                            (item) => item.platform === gamePlatform
                          );
                          const platformIsMaintain =
                            platformConfig?.isUnderMaintenance === true;
                          return (
                            <div
                              onClick={() => {
                                if (platformIsMaintain) {
                                  return;
                                }
                                dispatch(storeGameConfig(game));
                                dispatch(CloseMenu());

                                if (isMobile) {
                                  navigate(
                                    `game-confirm/${gameName}/${gamePlatform}/${game.gameUid}`
                                  );
                                } else {
                                  navigate(
                                    `/gamebox/${gameName}/${gamePlatform}/${game.gameUid}`
                                  );
                                }
                              }}
                              className={`bg-base-white relative dark:bg-base-light-dark overflow-hidden hover:border-main-color shadow text-white cursor-pointer rounded-[7px] py-[18px] px-[18px] flex items-center justify-start gap-[15px] hover:bg-hover-transaction-card`}
                            >
                              {platformIsMaintain && (
                                <div className="absolute bg-[rgb(0,0,0,0.8)] z-[1] top-0 left-0 w-full h-full flex flex-col items-center justify-center">
                                  <span>{i18n("platformMaintain")}</span>
                                  <span className="text-sm tracking-tighter">
                                    {platformConfig?.maintenanceStartTime ||
                                      "-"}{" "}
                                    ~{platformConfig?.maintenanceEndTime || "-"}
                                  </span>
                                </div>
                              )}
                              <LazyImage
                                className={`w-[80px] h-[80px]`}
                                src={`${COMMON_WEB_PATH}/gameIcon/en/${gamePlatform}/${gameCode}.webp`}
                              />
                              <div className="flex flex-col gap-[5px]">
                                <span className="flex items-center font-medium">
                                  {gameName.split("").map((item) => {
                                    return (
                                      <span
                                        className={`text-base-light-dark dark:text-base-light-white ${
                                          search
                                            .toLowerCase()
                                            .includes(item.toLowerCase()) &&
                                          "!text-main-color"
                                        }`}
                                      >
                                        {item === " " ? <>&nbsp;</> : item}
                                      </span>
                                    );
                                  })}
                                </span>
                                <section className="flex">
                                  <span className="text-base-light-dark dark:text-base-light-white">
                                    {gamePlatform} - {i18n(gameSubType)}
                                  </span>
                                </section>
                              </div>
                            </div>
                          );
                        })}
                      </section>
                    )}
                  </section>
                </section>
              </>
            ) : (
              <>
                <FavoriteGameCatalog
                  wrapperClassName={`!px-[0px]`}
                  swiperProps={{
                    customPerView: "confirm-layout",
                  }}
                />

                <GameCatalog
                  wrapperClassName={`!px-[0px]`}
                  list={topGameList}
                  mainTitle={`Top`}
                  swiperProps={{
                    customPerView: "confirm-layout",
                  }}
                />
                <GameCatalog
                  wrapperClassName={`!px-[0px]`}
                  list={newGameList}
                  mainTitle={`News`}
                  swiperProps={{
                    customPerView: "confirm-layout",
                  }}
                />
              </>
            )}
          </LoadingBlock>
        </section>
      </motion.div>
    </CommonOpacityBackground>
  );
};

export default Search;
